import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import traditionalContent from '../assests/img/traditional-content.jpg';
import { Helmet } from 'react-helmet-async';


function Traditionaleducation() {
return (
    <div >
      <Helmet>
              <title>Traditional Education | State Board of Secondary Education, Delhi</title>
              <meta
                name="description"
                content="Learn more about Traditional Education | State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
              />
               <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
            </Helmet>
    
    <Header/>
    {/* <Showlist/> */}
    <div className='container'>
        <div className='about-banner'>
            <img src={aboutBanner} alt=""/>
             <h1 className='page-title'>Traditional Education</h1>
        </div>
    </div>
    
     <div className='container main-contant'>
        <div className='inner-page-container skill-education-container'>
          <div className="content-secion">
            <img src={traditionalContent} alt="State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy." />
          </div>
        </div>

      </div>
    <Footer/>
     </div>
    )
}

export default  Traditionaleducation;
